import { SET_PAGE } from '../constants/constants'

// eslint-disable-next-line default-param-last
const page = (state = {}, action) => {
    if (action.type === SET_PAGE) {
        return action.payload
    }

    return state
}

export default page
